/*  ========================================================================
    # Stores - Events
    ========================================================================  */

import { create } from 'zustand';

const useEventStore = create(set => ({
  selectedDates: [],
  addDate: date =>
    set(state => {
      if (state.selectedDates.find(elm => elm === date)) {
        return { selectedDates: state.selectedDates };
      } else {
        return { selectedDates: [...state.selectedDates, date] };
      }
    }),
  setSelectedDates: dates => set(() => ({ selectedDates: dates })),
  removeDate: date =>
    set(state => ({ selectedDates: state.selectedDates.filter(el => el !== date) })),
  removeAllDates: () => set(() => ({ selectedDates: [] }))
}));

export default useEventStore;
